import React from 'react';
import { Box, DialogActions } from '@mui/material';
import SubMatDialogFooterButton from './SubMatDialogFooterButton';

/**
 * theme.js 전역 스타일 덮어쓰기 + 서류보내기(SendMailDialog) medium 버튼과 동일 높이
 * - .MuiDialogActions-spacing { padding-left: 0 }
 * - .MuiDialogActions-root > button { font-size: 16px } → Box 내부 버튼도 동일 적용
 */
export const SUBMAT_TEMPLATE_DIALOG_ACTIONS_SX = {
  '&&': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    boxSizing: 'border-box',
    padding: '16px 24px 32px 16px !important',
    gap: 0,
  },
  '& .MuiButton-root': {
    fontSize: '16px !important',
    fontWeight: 500,
    width: 'auto',
    minWidth: 'unset !important',
    textTransform: 'none !important',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    lineHeight: 1.75,
    padding: '6px 16px !important',
  },
  '& .MuiButton-outlined': {
    borderWidth: '1px !important',
    padding: '5px 15px !important',
  },
  '& .MuiButton-contained': {
    boxShadow: 'none !important',
    '&:hover': {
      boxShadow: 'none !important',
    },
  },
  '& .MuiButton-startIcon': {
    marginRight: '8px !important',
    marginLeft: '-4px !important',
  },
  '& .MuiButton-startIcon > *:nth-of-type(1)': {
    fontSize: '20px !important',
  },
};

/** 모바일: 오른쪽 세 칸(보조·주요·닫기) 너비를 단계와 관계없이 같게 유지 */
const FIXED_SLOTS_SX = {
  ...SUBMAT_TEMPLATE_DIALOG_ACTIONS_SX,
  '&&': {
    ...SUBMAT_TEMPLATE_DIALOG_ACTIONS_SX['&&'],
    padding: '12px 12px 16px 12px !important',
    gap: '8px',
  },
  '& .footer-pdf .MuiButton-root': {
    width: '40px !important',
    minWidth: '40px !important',
    flex: '0 0 auto',
    padding: '6px !important',
  },
  '& .footer-pdf .MuiButton-startIcon': {
    margin: '0 !important',
  },
  '& .footer-slot': {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
  },
  '& .footer-slot .MuiButton-root': {
    width: '100% !important',
    minWidth: '0 !important',
    flex: '1 1 auto',
    fontSize: '14px !important',
    padding: '6px 4px !important',
  },
  '& .footer-slot .MuiButton-outlined': {
    padding: '5px 4px !important',
  },
};

/**
 * 템플릿 수정·발송 다이얼로그 하단 — PDF 좌 / (이전·다음·저장) 우, 버튼 크기·폰트 통일.
 * @param {React.ReactNode} [beforePrimary] — 저장/다음 왼쪽에 둘 버튼(예: 이전)
 * @param {boolean} [fixedSlots] — 모바일. 보조 칸을 비워 두어도 세 칸 너비를 유지
 * @param {boolean} [hideCancel] — 닫기 버튼을 두지 않음
 */
const SubMatTemplateDialogFooter = ({
  pdfButton,
  beforePrimary = null,
  primaryButton,
  onCancel,
  cancelLabel = '닫기',
  cancelDisabled,
  fixedSlots = false,
  hideCancel = false,
}) => (
  <DialogActions disableSpacing sx={fixedSlots ? FIXED_SLOTS_SX : SUBMAT_TEMPLATE_DIALOG_ACTIONS_SX}>
    {fixedSlots ? <Box className="footer-pdf">{pdfButton}</Box> : pdfButton}
    <Box
      sx={fixedSlots ? {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        gap: 1,
        minWidth: 0,
      } : {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        ml: 'auto',
      }}
    >
      {fixedSlots ? (
        <Box className="footer-slot">{beforePrimary}</Box>
      ) : beforePrimary}
      {fixedSlots ? <Box className="footer-slot">{primaryButton}</Box> : primaryButton}
      {!hideCancel && (fixedSlots ? (
        <Box className="footer-slot">
          <SubMatDialogFooterButton variant="outlined" onClick={onCancel} disabled={cancelDisabled}>
            {cancelLabel}
          </SubMatDialogFooterButton>
        </Box>
      ) : (
        <SubMatDialogFooterButton onClick={onCancel} disabled={cancelDisabled}>
          {cancelLabel}
        </SubMatDialogFooterButton>
      ))}
    </Box>
  </DialogActions>
);

export default SubMatTemplateDialogFooter;
